/**
 * Session Manager
 * Watches for inactivity while the user is authenticated and auto-logs
 * them out after a warning countdown. Mounted once inside the authenticated
 * layout - not present on the login page.
 */

import { useCallback } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { useIdleTimer } from '@/hooks/useIdleTimer'
import { SessionWarningModal } from '@/components/SessionWarningModal'

const IDLE_TIMEOUT_MS = 30 * 60 * 1000 // 30 minutes
const WARNING_MS = 60 * 1000 // show the countdown 60s before logout

export function SessionManager() {
  const { isAuthenticated, endSession } = useAuth()

  const handleIdle = useCallback(() => {
    endSession('idle')
  }, [endSession])

  const { isWarning, remainingSeconds, stayLoggedIn } = useIdleTimer({
    timeoutMs: IDLE_TIMEOUT_MS,
    warningMs: WARNING_MS,
    onIdle: handleIdle,
    enabled: isAuthenticated,
  })

  return (
    <SessionWarningModal
      isOpen={isWarning}
      remainingSeconds={remainingSeconds}
      onStayLoggedIn={stayLoggedIn}
      onLogoutNow={handleIdle}
    />
  )
}

export default SessionManager
